export var ProductDisabledReasons;
(function (ProductDisabledReasons) {
    ProductDisabledReasons["NotRosteredWithNWEA"] = "NotRosteredWithNWEA";
    ProductDisabledReasons["OrganizationNotLicensed"] = "OrganizationNotLicensed";
    ProductDisabledReasons["PendingAssessmentLockout"] = "PendingAssessmentLockout";
    ProductDisabledReasons["ProductHidden"] = "ProductHidden";
})(ProductDisabledReasons || (ProductDisabledReasons = {}));
